import { render, staticRenderFns } from "./DiaryAchievementItem.vue?vue&type=template&id=a8511cb6&scoped=true"
import script from "./DiaryAchievementItem.vue?vue&type=script&lang=ts"
export * from "./DiaryAchievementItem.vue?vue&type=script&lang=ts"
import style0 from "./DiaryAchievementItem.vue?vue&type=style&index=0&id=a8511cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8511cb6",
  null
  
)

export default component.exports